import { AUTHENTICATING_PIPEDRIVE_REQUEST, AUTHENTICATING_PIPEDRIVE_SUCCEDDED, AUTHENTICATING_PIPEDRIVE_FAILED,
    FETCHING_PIPEDRIVE_MASTER_CONFIG_REQUEST, FETCHING_PIPEDRIVE_MASTER_CONFIG_SUCCEDDED, FETCHING_PIPEDRIVE_MASTER_CONFIG_FAILED,
    UPDATING_PIPEDRIVE_REQUEST, UPDATING_PIPEDRIVE_SUCCEDDED, UPDATING_PIPEDRIVE_FAILED,
    SYNCHRONISING_PIPEDRIVE_REQUEST, SYNCHRONISING_PIPEDRIVE_SUCCEDDED, SYNCHRONISING_PIPEDRIVE_FAILED,
    FETCHING_PIPEDRIVE_SYNC_DETAILS_REQUEST, FETCHING_PIPEDRIVE_SYNC_DETAILS_SUCCEDDED, FETCHING_PIPEDRIVE_SYNC_DETAILS_FAILED,
} from '../actionTypes.jsx';


import axios from 'axios';

import {activatingIntegrationSuccedded } from '../integrations';

const apiUrl = `${process.env.REACT_APP_API_URL}`;

const PIPEDRIVE_BASE_URL = `${apiUrl}/api/2.0/integrations/pipedrive`;
const PIPEDRIVE_AUTHENTICATION_URL = `${PIPEDRIVE_BASE_URL}/authenticate`;

export function authenticateAccount(code){
  return function (dispatch) {
    dispatch(authenticatingAccount());

    const data = {
      code: code
    }

    return axios({
      method: 'POST',
      url: PIPEDRIVE_AUTHENTICATION_URL,
      params: data
    })
    .then((response) => {
      dispatch(authenticatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>
      dispatch(authenticatingAccountFailed(error))
    )
  }
}

function authenticatingAccount(){
  return {
    type: AUTHENTICATING_PIPEDRIVE_REQUEST,
    payload: {}
  }
}

function authenticatingAccountSuccedded(json){
  return {
    type: AUTHENTICATING_PIPEDRIVE_SUCCEDDED,
    payload: json
  }
}

function authenticatingAccountFailed(error){
  return {
    type: AUTHENTICATING_PIPEDRIVE_FAILED,
    payload: error
  }
}

/**
* Update pipedrive configuration
*/
export function updateConfiguration(configuration){
  return function (dispatch) {
    dispatch(updatingConfiguration());

    return axios({
      method: 'PUT',
      url: PIPEDRIVE_BASE_URL,
      data: configuration
    })
    .then((response) => {
      dispatch(updatingConfigurationSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>{
      dispatch(updatingConfigurationFailed(error))
    })
  }
}

function updatingConfiguration(){
  return {
    type: UPDATING_PIPEDRIVE_REQUEST,
    payload: {}
  }
}

function updatingConfigurationSuccedded(json){
  return {
    type: UPDATING_PIPEDRIVE_SUCCEDDED,
    payload: json
  }
}

function updatingConfigurationFailed(error){
  return {
    type: UPDATING_PIPEDRIVE_FAILED,
    payload: error
  }
}